export default __webpack_public_path__ + "static/kamil_drazkiewicz-49b3bca3970b5451f1b56c9700e85a91.png";